// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__unw1y","plus":"styles_plus__nziJT","key":"styles_key__c8Dbg"};